import PropTypes from 'prop-types'

import { getDisplayName, getUrlParam } from 'utils/mixpanel'

export const withAnalytics = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { mixpanel, location } = props

    const getDownloadOrderModalConfirmationSubmittedParams = ({
      formatSelected,
    }) => ({
      'Download Format': formatSelected,
      ...getUrlParam(location),
    })

    const trackers = {
      trackDownloadOrderModalConfirmationSubmitted: (config) =>
        mixpanel.track(
          'Orders List_Download Order Confirmation Modal Submitted',
          getDownloadOrderModalConfirmationSubmittedParams(config),
        ),
      trackDownloadOrderModalConfirmationCancelled: () =>
        mixpanel.track(
          'Orders List_Download Order Confirmation Modal Cancelled',
        ),
    }

    return <WrappedComponent {...props} {...trackers} />
  }

  Wrapper.propTypes = {
    mixpanel: PropTypes.object,
    location: PropTypes.object.isRequired,
  }
  Wrapper.defaultProps = {
    mixpanel: { track: () => {} },
  }

  Wrapper.displayName = `withAnalytics(${getDisplayName(WrappedComponent)})`
  return Wrapper
}

export default withAnalytics
